class alternateProductVariants extends HTMLElement {
  constructor() {
    super();
    this.requiredDataStractured = {
      s: [],
      m: [],
      l: [],
      xl: [],
      xxl: []
    }
    this.getProductsData();
    this.addEventListener('change', this.onVariantChange);
  }

  getProductsData() {
    const productsData = [];

    const stringProductsData = document.querySelectorAll('script[js-product-json]');
    
    stringProductsData.forEach((productDataString) => {
        const productData = JSON.parse(productDataString.textContent);
        productsData.push(productData);
    });
    console.log({productsData})
    productsData.forEach(product => {
    product.variants.forEach(variant => {
        const key = variant.title.toLowerCase();
        
        // Ensure the key exists in the object before spreading
        if (!this.requiredDataStractured[key]) {
            this.requiredDataStractured[key] = [];
        }
        
        this.requiredDataStractured[key] = [
            ...this.requiredDataStractured[key], 
            { 
                "productId": product.product_id,
                "available": variant.available 
            }
        ];
    });
});

  }

  onVariantChange(e) {
    this.updateOptions();
    const selectedSize = this.updateOptions().toLowerCase();
    console.log(selectedSize);
    this.productSoldOut(selectedSize);
  }

  productSoldOut(selectedSize) {
    this.requiredDataStractured[selectedSize].forEach((product) => {
      const productElement = document.querySelector(`[js-product-switcher][data-product-id="${product.productId}"]`);
      if(productElement){
        if(product.available) {
        document.querySelector(`[js-product-switcher][data-product-id="${product.productId}"]`).classList.remove('soldout');
      } else {
        document.querySelector(`[js-product-switcher][data-product-id="${product.productId}"]`).classList.add('soldout');
      }
      }
      else {
      console.warn(`Product switcher not found for productId: ${product.productId}`);
    }
    })
  }



  updateOptions() {
    return [...this.querySelectorAll('[js-size-input]:checked')].map((select) => select.value).toString();
  }
  

} 

customElements.define('hb-alt-product-variants', alternateProductVariants);
window.alternateProductVariants = alternateProductVariants;